export const CHART_COLORS = {
  primary: "#4012AB",
  primaryDark: "#2E0D7A",
  neutral: "#DFDEE2",
  axis: "#737373",
  tooltipBorder: "#e5e5e5",
  destructive: "#ef4444",
} as const;

// Categorical palette: 6 perceptually distinct hues for channel / category slots.
// Dominant stays palomma-primary; other slots are restrained accents (not neon).
export const CHART_SEQUENCE = [
  CHART_COLORS.primary, // violet
  "#0D9488", // teal
  "#D97706", // amber
  "#DB2777", // pink
  "#059669", // emerald
  "#475569", // slate
] as const;
